import { render, staticRenderFns } from "./BannerIconShootingType.vue?vue&type=template&id=e29ed87c&scoped=true"
import script from "./BannerIconShootingType.vue?vue&type=script&lang=js"
export * from "./BannerIconShootingType.vue?vue&type=script&lang=js"
import style0 from "./BannerIconShootingType.vue?vue&type=style&index=0&id=e29ed87c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29ed87c",
  null
  
)

export default component.exports